import type { Ref } from 'vue';
import { watch } from 'vue';
import type { HekateDisplayField, HekateDisplayForm } from '@onshape/www-inertia';
import { FieldHtmlNameUtil } from '@onshape/www-inertia';
import ExternalUtil from '../../../../ExternalUtil';
import CommonPreFilledProgressiveProfile from './CommonPreFilledProgressiveProfileDefinition';

/**
 * Only show the billing fields if the user is ready to buy now.
 */
export default class UpgradeStandardToPro extends CommonPreFilledProgressiveProfile {
  public override async realtimeBranchModifications({
    formDefinition,
  }: {
    formDefinition: Ref<HekateDisplayForm>;
  }): Promise<void> {
    super.realtimeBranchModifications({ formDefinition });

    const readyToUpgradeVal = ExternalUtil.findDisplayFieldValOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.readyToUpgrade,
    });
    const yearsOfCommitment = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.yearsOfCommitment,
    });
    const billingEmail = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.billingEmail,
    });
    const billingAddress = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.billingAddress,
    });

    const toHide: HekateDisplayField[] = [yearsOfCommitment, billingEmail, billingAddress];

    toHide.forEach((field) => {
      field.componentName = 'hidden-field';
    });

    watch(readyToUpgradeVal, (newVal) => {
      if (newVal === 'yes') {
        toHide.forEach((field) => {
          field.componentName = field.initialComponentName;
        });
      } else {
        toHide.forEach((field) => {
          field.val = '';
          field.componentName = 'hidden-field';
        });
      }
    });
  }
}
